import { ConfirmationModal } from "iq-blueberry"

import Img from "components/common/Img"

import useBbUploadButton from "./hook"
import "./style.styl"

const Icon = ({ icon }) => {
  if (icon) {
    return (
      <div className="bb-button-upload__left-icon">
        <Img src={icon} />
      </div>
    )
  }

  return null
}

const BbUploadButton = (props) => {
  const { children, onClick, icon, isChecked, onClickDelete } = props
  const {
    componentClass,
    handleDelete,
    isModalVisible,
    showConfirmationModal,
    hideConfirmationModal,
  } = useBbUploadButton(props)

  return (
    <>
      <ConfirmationModal
        title="Tem certeza que deseja deletar as imagens?"
        text="Novas imagens do documento serão necessárias para darmos continuidade."
        dangerButtonText="Deletar imagens"
        buttonText="Cancelar"
        isActive={isModalVisible}
        handleCloseModal={hideConfirmationModal}
        handleDangerButton={handleDelete}
        handleButton={hideConfirmationModal}
        hasButtons
      />

      <button className={componentClass} onClick={onClick}>
        <div className="bb-button-upload__content">
          {isChecked ? (
            <div className="bb-button-upload__left-icon">
              <Img src="images/check-circle-icon.svg" />
            </div>
          ) : (
            <Icon icon={icon} />
          )}

          {children}
        </div>

        {isChecked && onClickDelete ? (
          <div
            className="bb-button-upload__del-file"
            onClick={showConfirmationModal}
          >
            <Img src="images/trash-can.svg" />
          </div>
        ) : null}
      </button>
    </>
  )
}

export default BbUploadButton
